import { DataQueryKey, UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { ValidateOrderProductsParams } from './order-product.types';

export const getValidateOrderProductsKey = (
  params: ValidateOrderProductsParams,
): UseDataQueryKey => [DataQueryKey.ORDER_VALIDATE_PRODUCTS, params.orderId];
